module.exports = "<h2>Application Settings</h2>\r\n\r\nApplication Settings here..."


//////////////////
// WEBPACK FOOTER
// ./src/app/home/Settings.component.html
// module id = 1134
// module chunks = 1